export const SET_LOADING = 'src/store/transactionHistory/SET_LOADING'
export const SET_DOWNLOAD_LOADING = 'src/store/transactionHistory/SET_DOWNLOAD_LOADING'
export const SET_TRANSACTIONS = 'src/store/transactionHistory/SET_TRANSACTIONS'
export const SET_DOWNLOAD_RESPONSE = 'src/store/transactionHistory/SET_DOWNLOAD_RESPONSE'
// export const SET_DOWNLOAD_SUMMARY_LOADING = 'src/store/transactionHistory/SET_DOWNLOAD_SUMMARY_LOADING'
export const SET_TRANSACTIONS_SUMMARY = 'src/store/transactionHistory/SET_TRANSACTIONS_SUMMARY'
// export const SET_DOWNLOAD_SUMMARY_RESPONSE = 'src/store/transactionHistory/SET_DOWNLOAD_SUMMARY_RESPONSE'

